export type MyAgendaTab = "agenda" | "goals";

export interface MyAgendaFeatures {
    playbookEnabled: boolean;
    goalsEnabled: boolean;
}

export interface MyAgendaTabDef {
    tab: MyAgendaTab;
    label: string;
    path: string;
}

export const availableMyAgendaTabs = (features: MyAgendaFeatures): MyAgendaTabDef[] => {
    const tabs: MyAgendaTabDef[] = [];
    if (features.playbookEnabled) {
        tabs.push({ tab: "agenda", label: "My Agenda", path: "/my-agenda" });
    }
    if (features.goalsEnabled) {
        tabs.push({ tab: "goals", label: "My Goals", path: "/my-agenda/goals" });
    }
    return tabs;
};

export const resolveMyAgendaTab = (
    pathname: string,
    features: MyAgendaFeatures,
): MyAgendaTab | null => {
    const tabs = availableMyAgendaTabs(features);
    if (tabs.length === 0) {
        return null;
    }
    const requested: MyAgendaTab = pathname.startsWith("/my-agenda/goals")
        ? "goals"
        : "agenda";
    if (tabs.some(tab => tab.tab === requested)) {
        return requested;
    }
    return tabs[0].tab;
};
